// Custom animated SVG scenes for the "what welock does" cards.
// Pure CSS/SVG, no libraries. Each renders inside a fixed-height stage.

const stroke = "#00DC82";
const light = "#F3F4F6";
const dim = "#1E222D";

function Stage({ children }) {
  return (
    <div className="relative flex h-28 w-full items-center justify-center overflow-hidden">
      <svg viewBox="0 0 160 96" className="h-full w-full">
        <g stroke={dim} strokeWidth="1">
          {[...Array(4)].map((_, i) => (
            <line key={i} x1="0" y1={i * 32} x2="160" y2={i * 32} opacity="0.5" />
          ))}
        </g>
        {children}
      </svg>
    </div>
  );
}

export function LockScene() {
  return (
    <Stage>
      <g className="scene-lock-shackle">
        <path d="M64 50 V40 a16 16 0 0 1 32 0 V50" fill="none" stroke={light} strokeWidth="3" />
      </g>
      <rect x="58" y="50" width="44" height="34" rx="2" fill="none" stroke={stroke} strokeWidth="3" />
      <circle cx="80" cy="64" r="3.5" fill={stroke} />
      <rect x="78.5" y="64" width="3" height="10" fill={stroke} />
    </Stage>
  );
}

export function VestScene() {
  const bars = [
    { x: 44, h: 26, d: "0s" },
    { x: 66, h: 40, d: "0.25s" },
    { x: 88, h: 30, d: "0.5s" },
    { x: 110, h: 52, d: "0.75s" },
  ];
  return (
    <Stage>
      <line x1="34" y1="80" x2="126" y2="80" stroke={dim} strokeWidth="1.5" />
      {bars.map((b) => (
        <rect
          key={b.x}
          className="scene-vest-bar"
          style={{ animationDelay: b.d }}
          x={b.x}
          y={80 - b.h}
          width="12"
          height={b.h}
          fill={stroke}
          opacity="0.9"
        />
      ))}
    </Stage>
  );
}

export function DistributeScene() {
  const targets = [
    { path: "M40,48 L124,22", cy: 22 },
    { path: "M40,48 L124,48", cy: 48 },
    { path: "M40,48 L124,74", cy: 74 },
  ];
  return (
    <Stage>
      {targets.map((t, i) => (
        <path key={`l${i}`} d={t.path} stroke={dim} strokeWidth="1.5" fill="none" />
      ))}
      <circle cx="40" cy="48" r="6" fill="none" stroke={light} strokeWidth="2.5" />
      {targets.map((t, i) => (
        <circle key={`e${i}`} cx="124" cy={t.cy} r="4" fill="none" stroke={stroke} strokeWidth="2" />
      ))}
      {targets.map((t, i) => (
        <circle
          key={`d${i}`}
          className="scene-flow-dot"
          style={{ offsetPath: `path('${t.path}')`, animationDelay: `${i * 0.3}s` }}
          r="3"
          fill={stroke}
        />
      ))}
    </Stage>
  );
}

export function AutomateScene() {
  return (
    <Stage>
      <g className="scene-spin">
        <rect
          x="60" y="28" width="40" height="40"
          transform="rotate(45 80 48)"
          fill="none" stroke={dim} strokeWidth="2"
          strokeDasharray="6 8"
        />
      </g>
      <g className="scene-spin-rev">
        <rect
          x="66" y="34" width="28" height="28"
          transform="rotate(45 80 48)"
          fill="none" stroke={stroke} strokeWidth="2"
        />
      </g>
      <g className="scene-ring">
        <circle cx="80" cy="48" r="5" fill={stroke} />
      </g>
      <circle cx="80" cy="18" r="2.5" fill={light} />
      <circle cx="110" cy="48" r="2.5" fill={light} />
      <circle cx="80" cy="78" r="2.5" fill={light} />
      <circle cx="50" cy="48" r="2.5" fill={light} />
    </Stage>
  );
}

export const SCENES = {
  Lock: LockScene,
  Vest: VestScene,
  Distribute: DistributeScene,
  Automate: AutomateScene,
};
